<template>
	<div>
		<transition name="fade">
			<div class="app-loader">
				<img src="./../../assets/cndef-loader.gif" alt="Cargando...">
			</div>
		</transition>
	</div>
</template>

<script>
	import axios from 'axios';

	export default {
		data(){
			return {
				tokenNacionalUy: this.$route.params.accesoToken,
				SDTUsuario7egend: {}
			}
		},
		computed: {
			loggedIn(){
				return this.$store.getters.loggedIn
			}
		},
		async mounted() {
			if(this.loggedIn){
				await this.cerrarSesion();
			}
			await this.tokenNacional();
			await this.replicarSesion();
		},
		methods: {
			async tokenNacional(){
				// console.log('	tokenNacional 1');
				try {
					// console.log('	tokenNacional 2');
					const params = {
						"platform": "1", 
						"locale": "es", 
						"fields": "expires_at,access_token,user(first_name,last_name,identification,phone,email,birthday,country(iso2_code,name,nationality),city)"
					}

					// console.log('	tokenNacional 3');

					let response = await axios.get(process.env.VUE_APP_URL_API_7EGEND + '/v1/sessions', { headers: { "Authorization" : `${this.tokenNacionalUy}`}, params: params });

					// console.log('	tokenNacional 4');

					if(response.data.data.user.email){
						// console.log('	tokenNacional 5');

						// Guardo el token en Vuex
						await this.$store.dispatch('setTokenNacional', response.data.data.access_token)

						// Replicar sesión
						this.SDTUsuario7egend = {
							expires_at: response.data.data.expires_at,
							first_name: response.data.data.user.first_name,
							last_name: response.data.data.user.last_name,
							identification: response.data.data.user.identification,
							email: response.data.data.user.email,
							country: response.data.data.user.country.name,
							city: response.data.data.user.city,
							birthday: response.data.data.user.birthday,
							phone: response.data.data.user.phone
						}

						// console.log('	tokenNacional 6');
					} else {
						window.location.href = process.env.VUE_APP_URL_NACIONALUY;
						// console.log('	tokenNacional 7');
					}
				} catch (error) {
					// Si el ws arroja error, redirijo a Nacional.uy
					window.location.href = process.env.VUE_APP_URL_NACIONALUY;
					// console.log('	tokenNacional 8');
				}
			},
			async replicarSesion(){
				// console.log('	replicarSesion 1');
				try {
					// console.log('	replicarSesion 2');
					// Consumo web service de token mediante Axios
					let response2 = await axios.post('/WSPropagarSesion', { SDTUsuario7egend: this.SDTUsuario7egend, JWTClienteId: 1 });

					// console.log('	replicarSesion 3');

					if(response2.data.ErrorCod === 0){
						// console.log('	replicarSesion 4');
						localStorage.setItem('access_token', response2.data.JWTAccesoId)
						localStorage.setItem('usuario_id', response2.data.UsuarioId)
						localStorage.setItem('usuario_nombre', response2.data.UsuarioPersonaNombre)
						localStorage.setItem('usuario_iniciales', response2.data.UsuarioPersonaIniciales)
						this.$store.commit('retrieveToken', response2.data.JWTAccesoId)
						this.$store.commit('setearNombre', response2.data.UsuarioPersonaNombre)
						this.$store.commit('setearIniciales', response2.data.UsuarioPersonaIniciales)
						this.$store.commit('setearUsuarioId', response2.data.UsuarioId)

						this.$router.push({ name: 'home' })
					} else {
						if(response2.data.ErrorCod === 20 || response2.data.ErrorCod === 21 || response2.data.ErrorCod === 22){
							this.$router.push({ name: 'actualizar-datos' })
						} else {
							window.location.href = process.env.VUE_APP_URL_NACIONALUY;
							// console.log('	replicarSesion 5');
						}
					}
				} catch (error) {
					window.location.href = process.env.VUE_APP_URL_NACIONALUY;
					// console.log('	replicarSesion 6');
				}
			},
			async cerrarSesion(){
				// Elimino la sesión de ticketing
				localStorage.removeItem('access_token')
				localStorage.removeItem('usuario_nombre')
				localStorage.removeItem('usuario_iniciales')
				localStorage.removeItem('usuario_id')
				this.$store.commit('destroyToken')
				this.$store.commit('destruirNombre')
				this.$store.commit('destruirIniciales')
				this.$store.commit('destruirUsuarioId')
			}
		}
	}
</script>